// Decides which save control the record screen shows.
//
// A git-enabled record shows the SaveSplitButton so the user can choose between
// "Save" and "Save and commit"; which of the two is the primary (single-click)
// action is a separate decision driven by GIT_AUTOCOMMIT_ENABLED (the
// `canCommit` prop). A record shows a plain Save button when there is nothing to
// commit: either its container is not git-enabled (`isGitEnabled` not true), or
// the record itself opts out of git tracking (`track_in_git === false`).
//
// `isGitEnabled` is the authoritative container-level signal
// (getRecordOrContainerIsGitEnabled) — the same one that gates the Commit
// action. It is used instead of inferring git-enablement from the record's own
// `track_in_git`, because a non-git record can carry `track_in_git === null`
// (not `false`), which would otherwise be mistaken for a git-tracked record.
export const shouldShowPlainSaveButton = ({
    isGitEnabled,
    trackInGit,
    isNewRecord,
    newRecordTrackInGit,
}: {
    // getRecordOrContainerIsGitEnabled(...) for the record's container
    // (undefined until resourceData has loaded).
    isGitEnabled?: boolean;
    // resourceData.track_in_git of an existing record (undefined until loaded,
    // null when unset — both mean "inherit the container default" = tracked).
    trackInGit?: boolean | null;
    isNewRecord?: boolean;
    // track_in_git chosen in the form while creating a new record.
    newRecordTrackInGit?: boolean | null;
}): boolean =>
    isGitEnabled !== true ||
    (isNewRecord ? newRecordTrackInGit === false : trackInGit === false);
